import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import * as ReactIntl from "react-intl"
import Card from "../../../card"
import * as CashFlowDomain from "../../../../domain/sfp/cash-flow-domain"
import * as LoanDomain from "../../../../domain/sfp/loan-domain"
import * as ProspectiveDomain from "../../../../domain/sfp/prospective-domain"
import * as ScenarioDomain from "../../../../domain/sfp/scenario-domain"
import * as PpiDomain from "../../../../domain/sfp/ppi-domain"
import * as Model from "../../../../model"
import { FooterItem, LinkFooterItem } from "../../../card/footer-item"

interface Props {
	year: number
}
interface state {
	currentYear: boolean
	nextYear: boolean
}
class Yearmodification extends React.Component<Props, state> {
	state = {
		currentYear: true,
		nextYear: true
	}
	HandlecurrentYear = (event) => {
		if (event.target.value == 2) {
			this.setState({ currentYear: true })
		} else {
			this.setState({ currentYear: false })
		}
	}
	HandleNextYear = (event) => {
		if (event.target.value == 2) {
			this.setState({ nextYear: true })
		} else {
			this.setState({ nextYear: false })
		}
	}
	render() {
		const { currentYear, nextYear } = this.state
		return <div className={`card`}>
			<div>
				<header className="card-header">
					<h2 className="card-header-title">
						Modification des valeurs dans le tableau de répartition par service
					</h2>

				</header>
			</div>
			<div className="card-footer" style={{ borderTop: "0px" }}>
				<div className="card-footer-item" style={{ display: "grid" }}>
					<p>{this.props.year}</p>
					<label className="radio" style={{marginLeft:"0px"}}>
						<input
							checked={!currentYear}
							onChange={(event) => this.HandlecurrentYear(event)}
							required
							type="radio"
							value="1" /> Oui
					</label>
					<label className="radio" style={{marginLeft:"0px"}}>
						<input
							checked={currentYear}
							onChange={(event) => this.HandlecurrentYear(event)}
							required
							type="radio"
							value="2" />Non
					</label>
				</div>
				<div className="card-footer-item" style={{ display: "grid" }}>
					<p>{this.props.year + 1}</p>
					<label className="radio" style={{marginLeft:"0px"}}>
						<input
							checked={!nextYear}
							onChange={(event) => this.HandleNextYear(event)}
							required
							type="radio"
							value="1" /> Oui
					</label>
					<label className="radio" style={{marginLeft:"0px"}}>
						<input
							checked={nextYear}
							onChange={(event) => this.HandleNextYear(event)}
							required
							type="radio"
							value="2" />Non
					</label>
				</div>
			</div>
		</div>
	}

}

export default Yearmodification






// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/YearModification_card/index.tsx